import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CleanLetterhead, CleanFooter, Section, SectionNumberingProvider, TemplateDocument, v, } from '../../../atoms/index.js';
import { asDataTableRows } from '../../../data-table.js';
/** Columns of the horizontal apartment list (lägenhetsförteckning). */
const APARTMENT_COLUMNS = [
    { key: 'lagenhetsnummer', label: 'Lägenhetsnr', width: '6rem' },
    { key: 'adress', label: 'Adress', width: '14rem' },
    { key: 'antal_rum', label: 'Antal rum', width: '5rem' },
    { key: 'yta_kvm', label: 'Yta (m²)', width: '5rem' },
    { key: 'hyra_manad', label: 'Hyra (kr/mån)', width: '7rem' },
];
export const metadata = {
    templateKey: 'lagenhetsforteckning',
    version: 'v1',
    category: 'Övriga avtal',
    title: 'Lägenhetsförteckning',
    shortTitle: 'Lägenhetsförteckning',
    // The real bilaga name is the user's `document_title` override.
    titleFromValueKey: 'document_title',
    // No form number on a clean document — CleanLetterhead/CleanFooter omit it.
    formNumber: '',
    preamble: '',
    description: 'En bilaga med en horisontell lägenhetsförteckning. Bifogas valfritt avtal ' +
        'och har ingen egen signering — den följer med det signerade avtalet.',
    // Draft: registered + visible in /dev/templates, hidden from the tenant
    // catalog. Flip to 'active' (and pick real attachableTo parents) once the
    // framställan behaviour is settled.
    status: 'draft',
    attachableTo: ['*'],
    partySlots: [],
    sections: [{ ref: 'lagenheter', title: 'Lägenhetsförteckning' }],
};
export const variableSchema = [
    {
        key: 'document_title',
        label: 'Dokumenttitel',
        type: 'text',
        section: 'Dokument',
        default: 'Lägenhetsförteckning',
        requiredAtFinal: true,
        help: 'Visas överst i dokumentet (om sidhuvud är på) och blir bilagans namn.',
    },
    {
        key: 'show_header',
        label: 'Lägg till sidhuvud',
        type: 'boolean',
        section: 'Dokument',
        default: true,
        help: 'Visar dokumenttiteln under logotyperna. Logotyperna visas alltid.',
    },
    {
        key: 'units',
        label: 'Lägenheter',
        type: 'data_table',
        section: 'lagenheter',
        columns: APARTMENT_COLUMNS,
        help: 'En rad per lägenhet. Lägg till, ta bort och sortera raderna fritt.',
    },
];
export const sampleValues = {
    document_title: 'Lägenhetsförteckning – Kvarteret Eken',
    show_header: true,
    units: [
        { lagenhetsnummer: '1001', adress: 'Ekgatan 1A', antal_rum: '2', yta_kvm: '58', hyra_manad: '8 900' },
        { lagenhetsnummer: '1002', adress: 'Ekgatan 1A', antal_rum: '3', yta_kvm: '74', hyra_manad: '10 400' },
        { lagenhetsnummer: '1003', adress: 'Ekgatan 1B', antal_rum: '1', yta_kvm: '41', hyra_manad: '7 200' },
    ],
};
/** The horizontal apartment list table. */
function ApartmentTable({ values, }) {
    const rows = asDataTableRows(values.units);
    return (_jsx("div", { className: "max-w-full overflow-x-auto", children: _jsxs("table", { className: "w-full min-w-max border-collapse text-[9px]", children: [_jsx("thead", { children: _jsx("tr", { children: APARTMENT_COLUMNS.map((c) => (_jsx("th", { className: "border border-stone-400 bg-stone-100 px-1 py-0.5 text-left font-semibold", style: { minWidth: c.width }, children: c.label }, c.key))) }) }), _jsx("tbody", { children: rows.length === 0 ? (_jsx("tr", { children: _jsx("td", { colSpan: APARTMENT_COLUMNS.length, className: "border border-stone-400 px-1 py-2 text-center italic text-stone-400", children: "(Inga l\u00E4genheter ifyllda \u00E4nnu)" }) })) : (rows.map((row, i) => (_jsx("tr", { children: APARTMENT_COLUMNS.map((c) => (_jsx("td", { className: "border border-stone-400 px-1 py-0.5", children: v(row[c.key]) }, c.key))) }, i)))) })] }) }));
}
export function Letterhead({ values, } = {}) {
    const showHeader = values?.['show_header'] !== false;
    const title = (values?.['document_title'] ?? '').trim() || 'Lägenhetsförteckning';
    return _jsx(CleanLetterhead, { title: showHeader ? title : null });
}
export function PageFooter() {
    return _jsx(CleanFooter, {});
}
export function Body({ values, mode, }) {
    return (_jsx(SectionNumberingProvider, { sections: metadata.sections ?? [], values: values, mode: mode, children: _jsx(Section, { sectionRef: "lagenheter", title: "L\u00E4genhetsf\u00F6rteckning", children: _jsx(ApartmentTable, { values: values }) }) }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, { values: props.values }), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map